import React, {useState, useEffect} from 'react'
import Images from '../../../media/images'
import { useParams } from 'react-router-dom'
import api, { url } from '../../../api/api'
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';

const EditProfile = () => {

    const {id} = useParams()
    const [img, SetImg] = useState('')
    const [user, setUsers] = useState({})
    const { register, handleSubmit, setValue } = useForm();
    const [changed, setChanged] = useState(true)

    useEffect(()=> {
        api.get('/users/me/')
        .then(response=> {
            // console.log(response.data[0])
            setUsers(response.data[0])
        }).catch(error=> {
            console.log(error)
            
        })
    },[img,changed])


    useEffect(()=> {
      if(img !== ''){
        const formData = new FormData();
        formData.append("image", img)
        api.patch('/users/me/', formData)
        .then(response=>{
            console.log(response.data)
            SetImg('')
            
        }).catch(error=> {
            console.log(error)
            SetImg('')
        })
      }
    },[img])
    

    const handleSub = (data) => {
        // console.log(data)

        // const profile = {
        //    f_name : data.f_name,
        //    l_name : data.l_name,
        //    address : data.address,
        // }
        // const newData = {
        //    profile,
        //    phone : data.phone,
        //    email : data.email
        // }

        api.patch('/users/me/', data)
        .then(response=> {
            toast.success("Data Registered Successfully")
            setChanged(!changed)
        }).catch(err=> {
          toast.error("Something went wrong")
        })




    }

  return (
    <div>
        <div className="">
              <h1 className="text-primary-red font-Rakkas mt-2 text-center text-3xl font-bold lg:!mt-6">
                Edit Profile
              </h1>
              <div className="">
                {/* <img src="./images/title-border.png" alt="" className="mx-auto mt-4"/> */}
                <img src={Images.title_border} alt="" className="mx-auto mt-4" />
              </div>
              <div className="">
                <form  onSubmit={handleSubmit(handleSub)}>
                  <div className="mt-10 flex items-center justify-center gap-5">
                    <div className="h-28 w-28">
                      {
                        user?.profile?.image ?
                        <img className="h-full w-full rounded-full object-cover" 
                         src={ user?.profile?.image} alt=""/>
                        : "No image"
                      }
                    </div>
                    <div className="relative">
                      <div className="bg-primary-blue animation font-Berkshire mt-5 !cursor-pointer rounded-xl px-5 py-3 text-white hover:bg-blue-900 lg:mt-0">
                        Change Image
                      </div>
                      <input type="file" name="" id="" className="bg-primary-green absolute top-0 h-full w-full cursor-pointer opacity-0"
                       onChange={(e)=> SetImg(e.target.files[0])}
                      />
                    </div>
                  </div>
                  <div className="font-Acme mt-3 grid px-3 md:px-10 lg:!grid-cols-2 xl:gap-10">
                    <div className="mt-3 flex flex-col gap-2">
                      <label htmlFor="c-name" className="font-semibold">First Name<span className="text-primary-red">*</span></label>
                      <div className="">
                        <input required="" type="text" placeholder="First Name" 
                        className="order-input w-full"
                        {...register("f_name", {required: true}, setValue("f_name",user?.profile?.f_name ?? ""))}
                        />
                      </div>
                    </div>
                    <div className="mt-3 flex flex-col gap-2">
                      <label htmlFor="c-name" className="font-semibold">Last Name<span className="text-primary-red">*</span></label>
                      <div className="">
                        <input required="" type="text" placeholder="Last Name" className="order-input w-full"
                        {...register("l_name", {required: true}, setValue("l_name", user?.profile?.l_name ?? ""))}
                        
                        />
                      </div>
                    </div>
                    <div className="mt-3 flex flex-col gap-2">
                      <label htmlFor="c-name" className="font-semibold">Email<span className="text-primary-red">*</span></label>
                      <div className="">
                        <input required="" type="email" placeholder="example@gmil.com" className="order-input w-full"
                        {...register("email", {required: true}, setValue("email", user?.email ?? ""))}
                        />
                      </div>
                    </div>
                    <div className="mt-3 flex flex-col gap-2">
                      <label htmlFor="c-name" className="font-semibold">Phone Number<span className="text-primary-red">*</span></label>
                      <div className="">
                        <input required="" type="number" placeholder="986273223" className="order-input w-full"
                         {...register("phone", {required: true}, setValue("phone",user?.phone ?? ""))}
                        />
                      </div>
                    </div>
                    <div className="mt-3 flex flex-col gap-2">
                      <label htmlFor="c-name" className="font-semibold">Address<span className="text-primary-red">*</span></label>
                      <div className="">
                        <input required="" type="text" placeholder="Address" className="order-input w-full"
                          {...register("address", {required: true}, setValue("address", user?.profile?.address ?? ""))}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="bg-primary-blue animation mt-10 mb-16 inline-flex rounded-lg hover:bg-blue-700">
                    <button className="font-Berkshire py-3 px-10 text-xl font-bold text-white" type="submit">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
    </div>
  )
}

export default EditProfile